import React,{useState,useEffect} from 'react'
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { GetCustomerChatService } from '../../../services/ClientServices';

function GetCustomerChatList() {


    const [data,setdata] = useState([])
    const [selecteddata,setselecteddata] = useState({})
    const [modal, setModal] = useState(false);
    const [page,setpage] = useState(1)
    
    const navigate = useNavigate()
    const typeArr = [{label:'All Data',value:'All Data'},{label:'Sales User',value:'SalesUser'},{label:'Customer',value:'Customer'}]
    const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,type:'SalesUser' })


    // console.log("data",data?.filter((f)=>f?.full_data !== undefined))

  
    useEffect(()=>{
        getMetaMessage(page,search?.from_date1,search?.to_date1,search?.text,search?.type)
    },[page])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        width: 300,
        bgcolor: 'white',
        boxShadow: 4,
        p: 2,
        border:'0px solid white'
      };
    

  
  async function getMetaMessage(){
   const response = await GetCustomerChatService(page,search?.from_date1,search?.to_date1,search?.text,search?.type)
   setdata(response.data)
  }  


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetCustomerChatService(1, search?.from_date1, search?.to_date1,'',search?.type)
    setdata(response?.data)
  }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
   
        
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center border-b pb-2 ">
        <div className=' items-center justify-between'>
        <span className="font-[800] text-[14px]">Get Customer Chat List ({data?.pagination?.total})</span>

        <div className='flex md:hidden items-center text-[12px]'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
        </div>
        </div>


        <div className='flex flex-wrap items-center text-[12px]'>
          <div className='hidden md:flex items-center'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

             <Select 
                  showSearch
                  filterOption={false}
                  value={search?.type == '' ? null : search?.type}
                  bordered={false}
                  // onSearch={searchemployee}
                  className='border w-[120px] mr-2 rounded-md h-[28px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={typeArr}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Type</span>}
                  onChange={(e)=>setsearch({...search,type:e})}
                  />
          <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
          </div>
        </div> 
        </div>
        </div>


        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }

        {data?.datas?.length > 0 &&
        <div className='md:max-h-[85vh] border-t border-l border-r border-b mt-2'>
             {data?.datas?.length !== 0 &&
                   <>
                   {/* Desktop / tablet table */}
                   <div className='hidden md:block md:max-h-[85vh] md:overflow-y-auto'>
                   <div className='sticky top-0 z-50 flex border-b w-full bg-white py-[-5px] border-slate-200 relative'>
                      <h6 className='text-[12px] truncate w-[50px] px-2 py-1 font-[400] border-r'>Sl No</h6>
                      <h6 className='text-[12px] truncate flex-[3] px-2 py-1 font-[400] border-r capitalize'>All Info</h6>
                      <h6 className='text-[12px] truncate flex-[2] px-2 py-1 font-[400] border-r capitalize'>Error Info</h6>
                      <h6 className='text-[12px] truncate flex-1 px-2 py-1 font-[400] border-r capitalize'>Created On</h6>
                      <h6 className='text-[12px] truncate flex-1 px-2 py-1 font-[400] capitalize'>Status</h6>
                   </div>


                   {data?.datas?.map((d,i)=>(
                   <div key={d?._id} className='flex w-full border-b cursor-pointer z-0'  >
                      <h6 className='text-[11px] w-[50px] text-center px-2 py-1 border-r'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className='text-[11px] break-all flex-[3] px-2 py-1 border-r'>{JSON.stringify(d)}
                        <br></br>
                        <h6  className='text-[11px] pb-[5px]'>Source System : <span className='font-[800] uppercase'>{d?.message_sent_type}</span></h6>
                      </h6>
                      <h6 className='text-[11px] break-all flex-[2] px-2 py-1 border-r'>
                       <h6 className='bg-slate-100 p-1 text-[12px]'>Retry Count : <b>{d?.retry_count}</b></h6>
                        {d?.errors?.map((e)=>
                        <>
                        <h6 className='text-[11px]'>{e}</h6>
                        </>
                        )}
                      </h6>

                      <h6 className='text-[10px] flex-1 px-2 py-1 truncate border-r'>{moment(d?.createdAt).format('lll')}</h6>
                      <h6 className='text-[12px] truncate flex-1 px-2 py-1'>{d?.message_status}

                      <br></br>
                      </h6>
                   </div>))}
                   </div>

                   {/* Mobile card list */}
                   <div className='md:hidden space-y-2'>
                     {data?.datas?.map((d,i)=>(
                       <div key={d?._id} className='border rounded-md p-3 bg-white'>
                         <div className='flex items-start justify-between'>
                           <h6 className='text-[11px] font-[800] uppercase'>{d?.message_sent_type}</h6>
                           {d?.message_status && <h6 className='text-[10px] bg-slate-100 px-1.5 py-0.5 rounded capitalize'>{d?.message_status}</h6>}
                         </div>
                         <h6 className='text-[11px] break-all mt-1'>{JSON.stringify(d)}</h6>
                         <h6 className='bg-slate-100 p-1 text-[11px] mt-2 rounded'>Retry Count : <b>{d?.retry_count}</b></h6>
                         {d?.errors?.length > 0 && <div className='bg-red-50 rounded p-2 mt-1 text-[11px]'>{d?.errors?.map((e,ei)=>(<h6 key={ei}>{e}</h6>))}</div>}
                         <h6 className='text-[10px] text-slate-400 mt-2'>{moment(d?.createdAt).format('lll')}</h6>
                       </div>
                     ))}
                   </div>
                   </>}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default GetCustomerChatList